/* eslint-disable arrow-body-style */
/* eslint-disable no-secrets/no-secrets */
/* eslint-disable padding-line-between-statements */
import { useModal } from '@jutro/components';
import React, { useContext, useCallback, useState, useEffect, useMemo, useRef } from 'react'
import _, { filter } from 'lodash'
import { BreakpointTrackerContext } from '@jutro/layout';
import { TranslatorContext, IntlContext } from '@jutro/locale';
import { TFPACustomQuoteService } from 'tfpa-capability-quoteandbind-residential';
import { ViewModelForm, useDataRefresh, ViewModelServiceContext, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { EntityUtil } from '@xengage/gw-portals-util-js';
import AdditionalPremisesCoveragePopup from '../AdditionalPremisesCoveragePopup/AdditionalPremisesCoveragePopup';
import metadata from './AdditionalPremisesCoverage.metadata.json5';
import styles from '../Tables.module.scss';
import messages from '../Insureds.messages';

import { Button } from '@jutro/legacy/components';
import TFPACoverablesUtils from '../../../util/TFPACoverablesUtils';

function AdditionalPremisesCoverage(props) {
    const { submissionVM, updateWizardData, onValueChangeAndSync } = props;
    const ho225Label = "HO-225";
    const ho2NALabel = "NA";
    const [premisesVM, updatePremisesVM] = useState();
    const [premisesData, setPremisesData] = useState([]);
    const rowIndex = useRef();
    const [invalidComponent, setInvalidComponents] = useState([]);
    const [showErrors, setShowErrors] = useState(false);
    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const { showAlert, showConfirm, showModal } = useModal();
    const intl = useContext(IntlContext);
    
    const premisesTableData = _.get(submissionVM.value, 'lobData.homeowners_tfpa.coverages.additionalPremises_Ext')
    // const { onValidate } = useValidation('AdditionalPremisesCoverage');
    const { onValidate: setComponentValidation, isComponentValid } = useValidation('AdditionalPremisesCoverage');

    useEffect(() => {
        premisesTableData !== undefined ? setPremisesData(premisesTableData) : setPremisesData([]);
    }, []);

    const editRow = (index) => {
        const newVmData = createPremises(premisesData[index]);
        // updatePremisesVM(newVmData);
        rowIndex.current = index;
        
        const componentProps = {
            title: "Additional Premises",
            newAdditionalPremises: newVmData,
            occupancyTypeList,
            saveData: savePremises,
            cancelData: cancelPremises,
            isInvalid: findInvalidComponent,
            showErrors
        };
        
        showModal(
            <AdditionalPremisesCoveragePopup {...componentProps} />
        );
    };

    const deleteRow = (index) => {
        showConfirm({
            title: messages.wantToDelete,
            message: messages.insuredCancelMessage,
            status: 'warning',
            icon: 'mi-error-outline',
            confirmButtonText: messages.yesModal,
            cancelButtonText: messages.cancelModal,
        }).then((results) => {
            if (results === 'cancel' || results === 'close') {
                return _.noop();
            }
            const updatedPremisesData = premisesData.filter((_, i) => i !== index);
            setPremisesData(updatedPremisesData);
            submissionVM.lobData.homeowners_tfpa.coverages.additionalPremises_Ext.value = updatedPremisesData;
            updateWizardData(submissionVM);
            onValueChangeAndSync();
            return true;
        }, _.noop)
    };

    const actionButtons = (row, index) => (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
                className={styles.buttons}
                type="text"
                icon="gw-edit"
                onClick={() => editRow(index)}
                aria-label="Edit Row"
            />
            <Button
                className={styles.buttons}
                type="text"
                icon="gw-delete"
                onClick={() => deleteRow(index)}
                aria-label="Delete Row"
            />
        </div>
    );
    
    let oldVMData = [];
    
    const savePremises = useCallback((updatedData) => {
        const value = _.get(submissionVM, 'lobData.homeowners_tfpa.coverages.additionalPremises_Ext.value');
        if (rowIndex.current !== undefined) {
            const updatedPremisesData = value.map((item, index) => index === rowIndex.current ? updatedData.value : item);
            setPremisesData(updatedPremisesData);
            updatePremisesVM(updatedData.value);
            submissionVM.lobData.homeowners_tfpa.coverages.additionalPremises_Ext.value = updatedPremisesData;
            updateWizardData(submissionVM);
            onValueChangeAndSync();
            rowIndex.current = undefined;
        } else {
            const newItem = _.isUndefined(value) ? [updatedData.value] : [...value, updatedData.value] ;
            setPremisesData(newItem);
            updatePremisesVM(newItem);
            submissionVM.lobData.homeowners_tfpa.coverages.additionalPremises_Ext.value = newItem;
            onValueChangeAndSync();
        }
    }, []);
    
    const cancelPremises = () => {
        updatePremisesVM(oldVMData);
    };
    
    const findInvalidComponent = useCallback((isValid, componentID) => {
        if (isValid === false) {
            setInvalidComponents((oldValue) => [...oldValue, componentID]);
        }

        if (isValid === true) {
            setInvalidComponents((oldValue) => oldValue.filter((val) => val !== componentID));
        }
    }, []);
    
    const occupancyTypeList = [
        {
            code: 'owner',
            name: 'Owner Occupied'
        },
        {
            code: 'tenant',
            name: 'Tenant Occupied'
        }
    ];
    
    const getEndorsement = (item) => {
        let policyType;
        if (submissionVM) {
            policyType = TFPACoverablesUtils.policyType(submissionVM);
        } 
        // else if (policyChange) { // Uncomment when working on Policy changes
        //     policyType = policyChange.lobData.homeowners.coverables.policyType_Ext.value.code;
        // }
        if (policyType === 'DP2') {
            return;
        }
        
        // eslint-disable-next-line consistent-return
        return (item.occupancy === 'tenant') ? ho225Label : ho2NALabel;
    };
    
    const getLocation = (item) => {
        if (item.address) { 
            return item.address.displayName || `${item.address.addressLine1}, ${item.address.city}, ${item.address.state} ${item.address.postalCode}`;
        }
    };
    
    const getOccupancy = (item) => {
        return occupancyTypeList.map((value) => {
            if (value.code === item.occupancy) { return value.name; }
        });
    };
    
    
    const createPremises = (premises, context) => {
        return viewModelService.create(premises, 'pc', 'org.tfpa.edge.capabilities.quote.submission.lob.homeowners.coverages.dto.TFPAAdditionalPremiseDTO', context || {});
    };
    
    const addLocation = useCallback(() => {
        const newAddlPremises = createPremises({
            tempID: EntityUtil.nextId(),
            address: {country: 'US', state: 'TX', mustStandardize_Ext: false}
        });
        updatePremisesVM(newAddlPremises);
        const componentProps = {
            title: "Additional Premises",
            newAdditionalPremises: newAddlPremises,
            occupancyTypeList,
            saveData: savePremises,
            cancelData: cancelPremises,
            isInvalid: findInvalidComponent,
            showErrors
        };

        showModal(
            <AdditionalPremisesCoveragePopup {...componentProps} />
        );
    }, []);


    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        AddlInsCovTable: {
            data: premisesData,
        }
        
    }

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getOccupancy,
            getLocation,
            getEndorsement,
            actionButtons,
            addLocation
            
        },
        resolveComponentMap: { addlPrmsCovPopup: AdditionalPremisesCoveragePopup }
    }

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            model={submissionVM}
            onModelChange={updateWizardData}
            // onValueChange={writeValue}
            showErrors={showErrors}
            onValidationChange={setComponentValidation}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    )
}

export default withViewModelService(AdditionalPremisesCoverage)
